var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"text-h6",attrs:{"cols":"4"}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-col',{staticClass:"d-flex",attrs:{"cols":"8"}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }